// extracted by mini-css-extract-plugin
export default {"access-denied-container":"ProtectedRoute_access-denied-container__w9WSI"};